'use strict';
import get from 'lodash/get';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {stateGoExit} from '../../app/actions';
import {getAsset, getAssetModel, getAssetProject, getOrganization} from '../../app/model/reducers/state';
import {navStates} from '../../app/router';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {getAsString, getId} from '../../core-utilities/domain/ReduxUtils';
import {convertDMS, getLatLong} from '../../core-utilities/geo/utils';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {ASSET_PROJECT_COLLECTION} from '../../projects/domain/AssetProjectDomain';
import {ASSET_COLLECTION, toStringStatic} from '../domain/AssetDomain';
import {createAssetRequestModal} from '../redux/createAsset';
import {deleteAssetRequest} from '../redux/deleteAsset';
import {updateAssetRequestModal} from '../redux/updateAsset';
import largeTemplate from './home-components/large-body.html';
import smallTemplate from './home-components/small-body.html';


CacheTemplates.$inject = [
  '$templateCache',
];

export function CacheTemplates($templateCache) {
  $templateCache.put('assets/home-components/large-body.html', largeTemplate);
  $templateCache.put('assets/home-components/small-body.html', smallTemplate);
}

const VIEW_ACTIONS = {
  canEdit: 'organization_assets_edit',
  canSelectTags: 'asset_data-tags_select',
  canEditTags: 'asset_data-tags_edit',
};

AssetHomeController.$inject = [
  '$scope',
  '$miscUtils',
  '$ngRedux',
  '$ionicViewSwitcher',
  '$contextMenu',
  '$permissions',
  '$popup',
  '$modal',
  '$ionicSlideBoxDelegate',
  'FirebaseUtil',
  'AssetEditorFactory',
  'DataTagMixin',
  'timerExportService',
];

// TODO: add back button to the nav assets list
export function AssetHomeController(
  $scope,
  $miscUtils,
  $ngRedux,
  $ionicViewSwitcher,
  $contextMenu,
  $permissions,
  $popup,
  $modal,
  $ionicSlideBoxDelegate,
  FirebaseUtil,
  AssetEditorFactory,
  DataTagMixin,
  timerExportService,
) {
  const vm = $scope.assetHome = this;

  vm.viewProps = {
    onClickOptions: showMenu,
    onClickOptions_wrap: false,
  };

  vm.openContext = $miscUtils.blockPromise(showMenu);

  vm.save = $miscUtils.blockPromise(save);
  vm.editAssetData = editAssetData;
  vm.changeSlide = changeSlide;
  vm.nextSlide = nextSlide;
  vm.previousSlide = previousSlide;
  vm.manageDataTags = manageDataTags;

  vm.mapOpen = false;

  vm.tagManager = DataTagMixin(vm, $scope);
  $scope.$evalAsync(initMetrics);
  $permissions.bindOrg($scope, vm, VIEW_ACTIONS);

  vm.placeholderConfig = {
    noneSelected: 'entity.placeholder.asset.none.selected',
    noneExists: 'entity.placeholder.asset.none',
    create: showCreateAsset,
    select: onSelectAsset,
  };

  function onSelectAsset() {
    const rootState = $ngRedux.getState();
    if (getOrganization(rootState)) {
      $ngRedux.dispatch(stateGoExit({state: navStates.assetsList}));
    } else {
      $ngRedux.dispatch(stateGoExit({state: navStates.orgsList}));
    }
  }

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/

  vm.assetEditor = new AssetEditorFactory($scope, {
    getModel: () => getAsset($ngRedux.getState()),
  });
  $miscUtils.bindToExit($scope, isDirty, exitEditMode);


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  const CREATE_ASSET = {
    permission: 'organization_assets_edit',
    action: {messageId: 'assets.home.context.create.label', action: showCreateAsset},
  };

  const EDIT_ASSET = {
    permission: 'organization_assets_edit',
    action: {messageId: 'default.edit.label', action: showEditAsset},
  };

  const DELETE_ASSET = {
    permission: 'organization_assets_delete',
    action: {messageId: 'assets.home.context.delete.label', action: deleteAsset, important: true},
  };

  function showMenu() {
    const rootState = $ngRedux.getState();
    const orgId = getId(getOrganization(rootState));
    if (!orgId) return Promise.resolve(null);

    const checkActions = [];
    $contextMenu.addActionByOrg(checkActions, orgId, CREATE_ASSET);

    if (getAssetModel(rootState))
      $contextMenu.addActionByOrg(checkActions, orgId, EDIT_ASSET);

    // TODO: move to the tasks list and/or timer log view
    timerExportService.buildContextAction(checkActions, () => {
      timerExportService.exportAsset();
    });

    if (getAsset(rootState)) {
      $contextMenu.addActionByOrg(checkActions, orgId, DELETE_ASSET);
    }

    return $contextMenu.showByPermission({
      titleMessageId: 'assets.home.context.title.label',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function showCreateAsset() {
    $ngRedux.dispatch(createAssetRequestModal.actions.showModal());
  }

  function showEditAsset() {
    const asset = getAssetModel($ngRedux.getState());
    $ngRedux.dispatch(updateAssetRequestModal.actions.showModal({model: asset}));
  }

  function editAssetData() {
    // TODO: setup edit of any in-place edited fields
    // TODO: consider using the sub-header's edit button to switch to whatever tab the data tags are being displayed
    vm.tagManager.setEditMode();
  }

  function manageDataTags() {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    if (asset) {
      $ionicViewSwitcher.nextDirection('forward');
      $ngRedux.dispatch(stateGo('app.assets.data-tags-taggables', {
        collection: ASSET_COLLECTION,
        id: getId(asset),
      }));
    }
  }

  function deleteAsset() {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    const label = getAsString(asset, toStringStatic);
    const action = deleteAssetRequest.actions.sendRequest({
      label,
      id: getId(asset),
    });
    if (asset) {
      // TODO(i18n): translate task delete confirmation
      return $popup
        .textInputConfirm({
          title: 'Delete Asset',
          /* eslint-disable-next-line max-len */
          body: `Are you sure you want to delete<br/>${label}<br/>Please enter<br/>DELETE<br/>and press OK to continue`,
          confirmText: 'DELETE',
        })
        .then(result => result ? $ngRedux.dispatch(action) : null);
    }
  }

  function save() {
    return vm.assetEditor.save().then(function () {
      const rootState = $ngRedux.getState();
      const asset = getAsset(rootState);
      updateLocation(get(asset, 'geo'));
    });
  }

  function isDirty() {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    return asset && asset.$isDirty() && vm.assetEditor.isEditMode();
  }

  function exitEditMode() {
    if (vm.assetEditor.isEditMode && vm.assetEditor.isEditMode())
      vm.assetEditor.revert();
  }

  /*****************************************************************************************************************
   * Presentation
   ****************************************************************************************************************/

  function changeSlide(index) {
    $ionicSlideBoxDelegate.$getByHandle('asset_home_handle').slide(index, 200);
  }

  function nextSlide() {
    $ionicSlideBoxDelegate.$getByHandle('asset_home_handle').next();
  }

  function previousSlide() {
    $ionicSlideBoxDelegate.$getByHandle('asset_home_handle').previous();
  }

  function initMetrics() {
    const leave$ = eventToObservable($scope, SCOPE_DESTROY);

    $ngRedux.state$
      .takeUntil(leave$)
      .map(getAsset)
      .distinctUntilChanged(null, asset => getId(asset))
      .subscribe(withNewAsset);

    $ngRedux.state$
      .takeUntil(leave$)
      .map(getAssetProject)
      .distinctUntilChanged(null, assetProject => getId(assetProject))
      .subscribe(withNewAssetProject);

    $ngRedux.state$
      .takeUntil(leave$)
      .map(state => get(getAsset(state), 'geo'))
      .distinctUntilChanged()
      .subscribe(updateLocation);

    const assetProjectId$ = $ngRedux.state$
      .takeUntil(leave$)
      .map(state => getId(getAssetProject(state)))
      .distinctUntilChanged();

    assetProjectId$
      .switchMap(id => id
        ? FirebaseUtil
          .firebaseRef(`${ASSET_PROJECT_COLLECTION}-metrics/${id}/data`)
          .observe('value')
        : Observable.of(null)
      )
      .subscribe(updateMetrics);

    assetProjectId$
      .map(id => id ? {id, collection: ASSET_PROJECT_COLLECTION} : {id: null, collection: null})
      .subscribe(updateFeedListProps);
  }

  function updateFeedListProps(props) {
    $scope.$evalAsync(function () {
      vm.feedListProps = props;
    });
  }

  function updateMetrics(ss) {
    $scope.$evalAsync(function () {
      vm.metrics = ss ? ss.val() : null;
    });
  }

  function updateLocation(geo) {
    $scope.$evalAsync(() => {
      const coords = getLatLong(geo);
      if (coords) {
        vm.coords = convertDMS(coords.lat, coords.lon);
      } else {
        vm.coords = '';
      }
    });
  }

  function withNewAsset(asset) {
    $scope.$evalAsync(() => {
      vm.asset = asset;
      if (asset) { // TODO: need to make sure this cleaned up properly
        vm.tagManager.bindTags(asset);
      } else {
        vm.tagManager.destroy();
      }
    });
  }

  function withNewAssetProject(assetProject) {
    $scope.$evalAsync(() => vm.assetProject = assetProject);
  }

  // TODO(Assets): check only for geo after asset saving refactor
  function getHasMap() {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    return Promise.resolve(!!get(asset, 'geo.properties.address'));
  }
}



// WEBPACK FOOTER //
// ./src/js/assets/controllers/AssetHomeController.js